var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenidades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Amenidades",
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.781,
    height: 217.342,
    viewBox: "0 0 235.781 217.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #418c5a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-1",
    d: "M89.354,269.935a4.608,4.608,0,1,0-3.256-1.352A4.608,4.608,0,0,0,89.354,269.935Z",
    transform: "translate(-47.909 -147.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-1",
    d: "M190.121,121.064a31.781,31.781,0,1,0,18.657-60.011A50.886,50.886,0,1,0,108.028,50.9c0,1.643.078,3.3.239,4.934a40.762,40.762,0,0,0-25.113,57.52H59.863a4.608,4.608,0,0,0,0,9.211h53.416v20.261H9.211V122.563H23.039a4.608,4.608,0,0,0,0-9.211H4.6a4.6,4.6,0,0,0-4.6,4.6v29.473a4.6,4.6,0,0,0,4.6,4.6H18.418V168.55H4.6A4.6,4.6,0,0,0,0,173.158v18.418a4.6,4.6,0,0,0,4.6,4.6H18.418v11.972H4.6a4.608,4.608,0,0,0,0,9.211h201.7a4.608,4.608,0,0,0,0-9.211h-.474c.03-.491.048-.987.048-1.482a26.352,26.352,0,0,0-42.362-20.957V140.447A34.776,34.776,0,0,0,190.121,121.064ZM93.9,113.352a31.529,31.529,0,0,1,20.288-49.439,4.6,4.6,0,0,0,3.756-5.377,41.671,41.671,0,1,1,80.581,5.377,4.6,4.6,0,0,0,4.56,6.034c.3,0,.609-.022.917-.022a22.565,22.565,0,1,1-13.476,40.666,4.6,4.6,0,0,0-7.181,2.443,25.447,25.447,0,0,1-19.822,18.1v-30.39l22.857-22.857a4.611,4.611,0,1,0-6.521-6.521L163.509,87.713V69.282a4.608,4.608,0,0,0-9.211,0v29.56h0v5.425L136.475,86.422a4.611,4.611,0,1,0-6.521,6.521l24.074,24.074c.091.091.187.174.283.256V131.14a25.117,25.117,0,0,1-13.958-7.672,4.6,4.6,0,0,0-5.595-.869,31.546,31.546,0,0,1-12.263,3.782v-8.425a4.608,4.608,0,0,0-4.608-4.6Zm23.987,38.688a4.6,4.6,0,0,0,4.6-4.6V135.613a40.917,40.917,0,0,0,13.637-3.452,34.741,34.741,0,0,0,18.184,8.259v48.513a24.013,24.013,0,0,0-20.744,19.192h-29.49V196.18h13.815a4.6,4.6,0,0,0,4.6-4.6V173.158a4.6,4.6,0,0,0-4.6-4.608H104.072V152.032Zm-90.257,0H94.861v16.519H27.63ZM9.211,177.762H113.279v9.207H9.211ZM27.63,196.18H94.861v11.972H27.63Zm137.918.491a17.166,17.166,0,0,1,31.12,10c0,.5-.022.991-.065,1.482H143.06a14.78,14.78,0,0,1,17.627-9.7A4.6,4.6,0,0,0,165.548,196.671Z",
    transform: "translate(0 -0.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-1",
    d: "M359.575,115.628a4.6,4.6,0,1,0-3.256-1.348A4.6,4.6,0,0,0,359.575,115.628Z",
    transform: "translate(-200.665 -60.173)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenidades);
export default __webpack_public_path__ + "static/media/Amenidades.6aed529a26bd1894c98ea34abbc125b5.svg";
export { ForwardRef as ReactComponent };